export const AI_PRECONDITION_EVENT = 'voxpop-ai-precondition';
export const AI_QUOTA_EVENT = 'voxpop-ai-quota';

export const isAiPreconditionError = (error: unknown): boolean => {
  if (!error) return false;
  const err = error as { status?: number; code?: number | string; response?: { status?: number }; message?: string };
  const status = err.status ?? err.response?.status ?? err.code;
  if (status === 412 || status === '412') return true;
  const message = String(err.message || error);
  return message.includes('412') || message.toLowerCase().includes('precondition');
};

export const isAiQuotaError = (error: unknown): boolean => {
  if (!error) return false;
  const err = error as {
    status?: number | string;
    code?: number | string;
    response?: { status?: number };
    message?: string;
  };
  const status = err.status ?? err.response?.status ?? err.code;
  if (status === 429 || status === '429') return true;
  const message = String(err.message || error).toLowerCase();
  return (
    message.includes('resource_exhausted') ||
    message.includes('quota') ||
    message.includes('rate limit')
  );
};

export const notifyAiPreconditionError = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AI_PRECONDITION_EVENT));
};

export const notifyAiQuotaError = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AI_QUOTA_EVENT));
};
